import React from 'react';
import { HeaderWrapper, DateElement, Label, Value } from './shared.styles';

interface IDateRangeHeaderProps {
  startDate?: moment.Moment;
  endDate?: moment.Moment;
}
const DateRangeHeader: React.FC<IDateRangeHeaderProps> = ({
  startDate,
  endDate,
}) => {
  return (
    <HeaderWrapper>
      <DateElement>
        <Label>Start</Label>
        <Value>{startDate ? startDate?.format('MMM DD, YYYY') : '-'}</Value>
      </DateElement>
      <DateElement>
        <Label>End</Label>
        <Value>{endDate ? endDate?.format('MMM DD, YYYY') : '-'}</Value>
      </DateElement>
    </HeaderWrapper>
  );
};

export default DateRangeHeader;
